// Every platform phrase the web says, by key, with its English and the dormant
// az/ru still written beside it. Staff keys as written; kiosk.<key>; book.<key>.
import { WORDS } from '../../book/words'
import { phrases as kiosk } from '../kioskText'
import { phrases as staff } from '../staffText'

export interface SourcePhrase {
  key: string
  en: string
  /** A translation written in a TS table before languages became files. */
  legacy: Partial<Record<'az' | 'ru', string>>
}

let all: SourcePhrase[] | undefined

export function sourcePhrases(): SourcePhrase[] {
  if (all) return all
  const out: SourcePhrase[] = []
  const add = (key: string, p: { en: string; az?: string; ru?: string }) =>
    out.push({ key, en: p.en, legacy: { ...(p.az ? { az: p.az } : {}), ...(p.ru ? { ru: p.ru } : {}) } })
  for (const [key, p] of Object.entries(staff)) add(key, p)
  for (const [key, p] of Object.entries(kiosk)) add(`kiosk.${key}`, p)
  for (const [key, p] of Object.entries(WORDS)) add(`book.${key}`, p)
  all = out.sort((a, b) => (a.key < b.key ? -1 : a.key > b.key ? 1 : 0))
  return all
}

/** key → English, for every platform phrase. */
export function englishTable(): Record<string, string> {
  return Object.fromEntries(sourcePhrases().map((p) => [p.key, p.en]))
}
